import { useEffect, useRef } from 'react';
import { Route } from 'react-router-dom';
import { NavMarker } from 'react-rhumb';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import ManualDetectedTasksContainer from './ManualDetectedTasksContainer';
import { AsyncGrowthDashboardModalContainer } from '../components/trial/TrialModalContainer';
import SetupGuideLayout from '../components/setup/SetupGuideLayout';
import ConsolidatedUserGuideLayout from '../components/setup/ConsolidatedUserGuideLayout';
import SetupMetrics from '../components/setup/SetupMetrics';
import SetupGuideContextsProvider from '../contexts/SetupGuideContextsProvider';
import { useOnboardingSettingsError, useSelectedView, useSelectedViewSettings } from '../hooks/config';
import { trackPageView } from '../utils/usageTracker';
import { CHANGE_DEFAULT_HOMEPAGE_ROUTE, DATA_SYNC_MODAL_ROUTE, QUICK_INVITE_MODAL_ROUTE, TRIAL_ACTIVATION_SUCCESS_MODAL_ROUTE } from '../constants/routeConstants';
import AppLoadErrorPage from '../components/error/AppLoadErrorPage';
import UserGuideQuickInviteModal from '../components/invite/UserGuideQuickInviteModal';
import { useSyncProgressInTopNav } from '../hooks/task';
import { useSyncOnboardingSettings } from '../hooks/onboardingSettings';
import { useIsUnseated } from '../hooks/auth';
import ViewOnlySeatErrorPage from '../components/error/ViewOnlySeatErrorPage';
import UserGuideCesSurvey from '../components/UserGuideCesSurvey';
import GoogleContactsSyncAlert from '../components/GoogleContactsSyncAlert';
import ChangeDefaultHomepageModalPage from './ChangeDefaultHomepageModalPage';
import { CheckDefaultHomepageRedirect } from './CheckDefaultHomepageRedirect';
import DataSyncModalWrapper from 'setup-guide-ui/components/dataSync/DataSyncModalWrapper';
import Coac0002FeedbackSurvey from '../components/Coac0002FeedbackSurvey';
import { ActivationSuccessModalContainerWrapper } from '../components/trial/ActivationSuccessModalContainerWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TopNavProgressSyncer = () => {
  useSyncProgressInTopNav();
  return null;
};
const OnboardingSettingsSyncer = () => {
  useSyncOnboardingSettings();
  return null;
};
const SetupGuideContainer = () => {
  const isUnseated = useIsUnseated();
  const onboardingSettingsError = useOnboardingSettingsError();
  const isOnboardingSettingsLoaded = Boolean(useSelectedView());
  const {
    groupKey,
    onboardingKey
  } = useSelectedViewSettings() || {};
  const pageViewTracked = useRef(false);
  useEffect(() => {
    if (pageViewTracked.current === false && isOnboardingSettingsLoaded) {
      trackPageView('setup guide page', {
        groupKey,
        onboardingKey
      });
      pageViewTracked.current = true;
    }
  }, [groupKey, onboardingKey, isOnboardingSettingsLoaded]);
  if (onboardingSettingsError) {
    return /*#__PURE__*/_jsx(AppLoadErrorPage, {});
  }
  if (isUnseated) {
    return /*#__PURE__*/_jsx(ViewOnlySeatErrorPage, {});
  }
  if (!isOnboardingSettingsLoaded) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.loading"
      }),
      minHeight: 700,
      showLabel: true
    });
  }
  return /*#__PURE__*/_jsxs(NavMarker, {
    name: "APP_LOAD",
    children: [/*#__PURE__*/_jsx(AsyncGrowthDashboardModalContainer, {
      app: "setup-guide"
    }), /*#__PURE__*/_jsx(SetupGuideLayout, {
      children: /*#__PURE__*/_jsx(ConsolidatedUserGuideLayout, {})
    }), /*#__PURE__*/_jsx(ManualDetectedTasksContainer, {}), /*#__PURE__*/_jsx(Route, {
      component: UserGuideQuickInviteModal,
      path: QUICK_INVITE_MODAL_ROUTE
    }), /*#__PURE__*/_jsx(Route, {
      component: DataSyncModalWrapper,
      path: DATA_SYNC_MODAL_ROUTE
    }), /*#__PURE__*/_jsx(Route, {
      component: ActivationSuccessModalContainerWrapper,
      path: TRIAL_ACTIVATION_SUCCESS_MODAL_ROUTE
    }), /*#__PURE__*/_jsx(CheckDefaultHomepageRedirect, {}), /*#__PURE__*/_jsx(TopNavProgressSyncer, {}), /*#__PURE__*/_jsx(OnboardingSettingsSyncer, {}), /*#__PURE__*/_jsx(UserGuideCesSurvey, {}), /*#__PURE__*/_jsx(Coac0002FeedbackSurvey, {}), /*#__PURE__*/_jsx(GoogleContactsSyncAlert, {}), /*#__PURE__*/_jsx(SetupMetrics, {})]
  });
};
const SetupGuideContainerWithProviders = () => {
  return /*#__PURE__*/_jsxs(SetupGuideContextsProvider, {
    children: [/*#__PURE__*/_jsx(Route, {
      component: ChangeDefaultHomepageModalPage,
      path: CHANGE_DEFAULT_HOMEPAGE_ROUTE
    }), /*#__PURE__*/_jsx(SetupGuideContainer, {})]
  });
};
export default SetupGuideContainerWithProviders;